import styles from "styles/pages/feel-good-design/FeelGoodDesign.module.scss";

const Divider = () => {
    return (
        <span className={styles.divider}></span>
    )
}

export default Divider;